import { gql } from "@apollo/client";
import { Def_MutationResponse } from "./userCalls";

export const SYSTEM_EMAILS_INFO = gql`
  query SystemEmails($domain: String) {
    user {
      systemEmails(domain: $domain) {
        system_ids
        domain
        company_name
        company_id
      }
    }
  }
`;

export interface SystemEmailsItem {
  system_ids: number[]
  domain: string
  company_name?: string
  company_id: number
}

export interface SystemEmailsInfoResponse {
  user: {
    systemEmails: SystemEmailsItem;
  }
}

export const SYSTEM_EMAILS_MUTATION = gql`
  mutation SetCurrentUserAttentionEmailSystems($domain: String!, $systemIds: [Int!]!) {
    user {
      setCurrentUserAttentionEmailSystems(domain: $domain, system_ids: $systemIds) {
        code
        success
        message
      }
    }
  }
`

export interface SystemEmailsMutationResponse {
  user: {
    setCurrentUserAttentionEmailSystems: Def_MutationResponse;
  }
}